export default __webpack_public_path__ + "static/casperblockchain-logo-742c136c1a9d2e10a4c6e64867a6c248.svg";